import React from "react";

// =============================================================================
// PAGE LOADER
// =============================================================================
// PURPOSE: Loading spinner shown while page components lazy-load.
// =============================================================================

const PageLoader: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center bg-black/[0.03]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-glass-muted">Loading page...</p>
      </div>
    </div>
  );
};

export default PageLoader;
